/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { ScvSchemaProperty } from '../ScvSchemaProperty/ScvSchemaProperty.entity';

/**
 * The SCV schema entity type.
 * @export
 */
export type EntityScvSchema = io.TypeOf<typeof ScvSchema>;

/**
 * The SCV schema entity definition.
 * @export
 */
export const ScvSchema = io.type(
  {
    $schema: io.string,
    properties: io.record(io.string, ScvSchemaProperty),
    type: io.string,
    ['x-scv-event-properties']: io.record(io.string, ScvSchemaProperty),
  },
  `ScvSchema`,
);
